module.exports = __webpack_public_path__ + "fonts/IranSansFaNumRegular.d26ebd09.ttf";